import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { Panel } from "@/components/KpiCard";
import { api, errMsg } from "@/lib/api";

const VIDE = { actuel: "", nouveau: "", confirmation: "" };
const CHAMPS = [["actuel", "Mot de passe actuel", "current-password"], ["nouveau", "Nouveau mot de passe", "new-password"], ["confirmation", "Confirmer le nouveau", "new-password"]];

const probleme = (f) => {
  if (!f.actuel || !f.nouveau) return "";
  if (f.nouveau.length < 10) return "Au moins 10 caractères.";
  if (!/[A-Za-zÀ-ÿ]/.test(f.nouveau) || !/\d/.test(f.nouveau)) return "Au moins une lettre et un chiffre.";
  if (f.nouveau === f.actuel) return "Doit être différent de l'actuel.";
  if (f.confirmation && f.confirmation !== f.nouveau) return "La confirmation ne correspond pas.";
  return "";
};

export const MotDePassePanel = () => {
  const [f, setF] = useState(VIDE);
  const [busy, setBusy] = useState(false);
  const err = probleme(f);
  const pret = f.actuel && f.nouveau && f.confirmation === f.nouveau && !err;
  const envoyer = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { actuel: f.actuel, nouveau: f.nouveau });
      setF(VIDE);
      toast.success("Mot de passe changé. Les autres appareils devront se reconnecter.");
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <Panel title="Mot de passe" testId="password-panel">
      <form onSubmit={envoyer} className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
        {CHAMPS.map(([k, l, ac]) => (
          <div key={k} className="space-y-1">
            <Label htmlFor={`pwd-${k}`}>{l}</Label>
            <PasswordInput id={`pwd-${k}`} autoComplete={ac} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} testId={`password-${k}-input`} />
          </div>
        ))}
        <p className={`md:col-span-2 text-xs ${err ? "text-red-600" : "text-slate-500"}`} data-testid="password-hint">{err || "Au moins 10 caractères, avec au moins une lettre et un chiffre. Les autres appareils seront déconnectés."}</p>
        <Button type="submit" disabled={!pret || busy} className="bg-emerald-700 hover:bg-emerald-800" data-testid="password-submit-button">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <KeyRound className="h-4 w-4 mr-2" />}Changer le mot de passe
        </Button>
      </form>
    </Panel>
  );
};
